import React from 'react';
import { Head } from 'vite-react-ssg';

export const SITE_URL = 'https://vorstel.com';
export const SITE_NAME = 'Vorstel';

/**
 * Per-page SEO tags: unique <title>, meta description, canonical link,
 * Open Graph/Twitter tags, and optional JSON-LD structured data.
 *
 * Rendered through vite-react-ssg's <Head>, which is a thin wrapper around
 * react-helmet, so these tags are present in the actual server-rendered
 * HTML (not just injected client-side after hydration).
 */
const Seo = ({
  title,
  description,
  path = '/',
  image = `${SITE_URL}/og-image.jpg`,
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | AI-Enabled Digital Transformation Consulting`;
  const canonical = `${SITE_URL}${path === '/' ? '' : path}`;
  const jsonLdList = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Head>
      {/* Helmet's output is injected at the very top of <head>, ahead of the
          static tags in index.html — so charset must be declared here (and
          first) to actually land within the first bytes of <head>. */}
      <meta charSet="utf-8" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdList.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Head>
  );
};

export default Seo;
